// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#microphone-permission[data-v-74f5ae8b]{position:absolute;top:0;bottom:0;left:0;right:0;background-color:rgba(20,28,32,.9);z-index:99999;color:#fff}#microphone-permission .permission-message[data-v-74f5ae8b]{height:100%}#microphone-permission .permission-message h1[data-v-74f5ae8b]{font-size:24px;font-weight:500;margin:25px 0 15px}#microphone-permission .permission-message span[data-v-74f5ae8b]{max-width:350px;text-align:center;font-size:14px;margin-bottom:45px}", ""]);
// Exports
module.exports = exports;
